<script setup lang="ts">
import { ref, watch, defineEmits } from 'vue'

const emits = defineEmits(['update:modelValue'])
const props = withDefaults(
  defineProps<{
    modelValue: boolean
    title: string
    modalWidth: string
    modalHeight: string
    slotTextAreaHeight: string
  }>(),
  {
    title: "",
    modalWidth: "50%",
    modalHeight: "",
    slotTextAreaHeight: "",
  }
)
const status = ref(false as boolean)

watch(() => props.modelValue, (bool) => {
  status.value = bool
})
</script>
<template>
  <v-dialog
    id="modal"
    v-model="status"
    :width="props.modalWidth"
    :height="props.modalHeight"
    class="modal-class"
    persistent
  >
    <v-card
      style="background-color: white"
      class="w-100"
    >
      <v-card-title v-if="props.title" class="fs-4 fw-bold grey lighten-2 mx-auto mt-1">
        {{ props.title }}
      </v-card-title>
      <v-card-text
        :style="`height: ${props.slotTextAreaHeight}`"
      >
        <slot name="text"></slot>
      </v-card-text>
      <slot name="footer"></slot>
    </v-card>
  </v-dialog>
</template>
<style scooped>
.modal-class .v-overlay__content {
  min-height: 35%;
}
.v-dialog .v-overlay__content > .v-card {
  min-height: 30%!important;
}
</style>